export default __webpack_public_path__ + "static/3-d528dc1a3a9ec4bad82a953d1c4eb020.png";